import { NavLink } from "react-router-dom";
import { useState } from "react";
import { useCTA } from "../../../context/CTAContext";
import { motion } from "framer-motion";
import { createSubscriber } from "../../../controllers/subscribersController";
import { FaInstagram, FaFacebookF, FaXTwitter } from "react-icons/fa6";

const columns = [
  {
    heading: "Features",
    links: [
      { label: "Home", to: "/" },
      { label: "Casinos", to: "/casinos" },
      { label: "Blogs & News", to: "/blogs" },
      { label: "Testimonials", to: "#" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "About Us", to: "/about" },
      { label: "Contact Us", to: "/contact" },
      { label: "Feedback", to: "#" },
      { label: "Privacy Policy", to: "/privacy-policy" },
      { label: "Responsible Gambling", to: "/responsible-gambling" },
    ],
  },
];

const Footer = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [apiError, setApiError] = useState("");
  const { ctaHeight } = useCTA();

  // 🔹 Handle subscription form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");
    setIsSuccess(false);

    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setApiError("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    try {
      await createSubscriber(email, "N/A");
      setIsSuccess(true);
      setEmail("");
    } catch (err) {
      setApiError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer
      className={`bg-white dark:bg-[#12161f] text-gray-800 dark:text-gray-200 transition-colors duration-300`}
      style={{
        marginBottom: `-${ctaHeight}px`,
        paddingBottom: `${ctaHeight}px`,
      }}
    >
      <div className="w-full mx-auto max-w-[1400px] 2xl:max-w-[1600px] px-6 xl:px-10 py-12 sm:py-16">
        {/* Top Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start ">
          {/* Footer Links */}
          {columns.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <h4 className="text-sm font-semibold mb-3 text-gray-900 dark:text-gray-100">
                {col.heading}
              </h4>
              <ul className="space-y-3 ">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <NavLink
                      to={l.to}
                      className="text-sm text-gray-700 dark:text-gray-300 hover:text-primary hover:underline underline-offset-2 transition"
                    >
                      {l.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:w-[80%]">
            <h4 className="text-sm font-semibold mb-3 text-gray-900 dark:text-gray-100">
              Subscibe
            </h4>
            <div className="text-left lg:pl-4">
              <motion.p
                className="text-textLight/70 dark:text-textDark/70 text-sm  mb-3"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
              >
                Subscribe now to receive personalized offers and the latest
                updates on new casinos. Don’t miss out on the best deals—act
                fast and secure your spot!
              </motion.p>

              {/* 🔹 Form with success + error states */}
              <motion.form
                onSubmit={handleSubmit}
                className="flex flex-col  items-center gap-2"
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
              >
                <input
                  type="email"
                  required
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="h-9 w-full rounded-md border border-border dark:border-borderDark bg-cardLight dark:bg-cardDark px-3 text-sm text-textLight dark:text-textDark placeholder:text-textLight/60 dark:placeholder:text-textDark/60 outline-none focus:ring-2 focus:ring-primary/30 transition-colors duration-300"
                  autoComplete="email"
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`h-9 rounded-md w-full bg-primary px-4 text-white text-sm font-semibold hover:bg-primary-hover transition ${
                    isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                  }`}
                >
                  {isSubmitting ? "Subscribing..." : "Subscribe"}
                </button>
              </motion.form>

              {/* 🔹 Error message */}
              {apiError && (
                <motion.p
                  className="text-red-600 dark:text-red-400 text-sm mt-2"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  {apiError}
                </motion.p>
              )}

              {/* 🔹 Success message */}
              {isSuccess && (
                <motion.p
                  className="text-green-600 dark:text-green-400 text-sm mt-2"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                >
                  🎉 You’re in! Thanks for subscribing. Check your inbox for the
                  latest updates and offers.
                </motion.p>
              )}
            </div>
          </div>
        </div>

{/* Bottom Bar */}
<div className="mt-10 pt-6 border-t border-gray-200 dark:border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
  
  {/* Social Icons (LEFT now) */}
  <div className="flex items-center gap-3">
    <motion.a
      href="https://www.instagram.com/mrreelofficial"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Instagram"
      whileHover={{ y: -3, scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      className="w-9 h-9 rounded-full flex items-center justify-center
                 bg-gray-100 dark:bg-white/10
                 text-gray-700 dark:text-gray-200
                 hover:bg-primary hover:text-white
                 transition-all duration-300"
    >
      <FaInstagram size={16} />
    </motion.a>

    <motion.a
      href="https://www.facebook.com/people/Mr-Reel/61576904375279/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Facebook"
      whileHover={{ y: -3, scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      className="w-9 h-9 rounded-full flex items-center justify-center
                 bg-gray-100 dark:bg-white/10
                 text-gray-700 dark:text-gray-200
                 hover:bg-primary hover:text-white
                 transition-all duration-300"
    >
      <FaFacebookF size={15} />
    </motion.a>

    <motion.a
      href="https://x.com/MrReelOfficial"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="X"
      whileHover={{ y: -3, scale: 1.06 }}
      whileTap={{ scale: 0.96 }}
      className="w-9 h-9 rounded-full flex items-center justify-center
                 bg-gray-100 dark:bg-white/10
                 text-gray-700 dark:text-gray-200
                 hover:bg-primary hover:text-white
                 transition-all duration-300"
    >
      <FaXTwitter size={15} />
    </motion.a>
  </div>

  {/* Copyright (RIGHT now) */}
  <p className="text-xs text-gray-500 dark:text-gray-400">
    © {new Date().getFullYear()} Mr-Reel. All rights reserved.
  </p>
</div>
      </div>
    </footer>
  );
};

export default Footer;
